module.exports = __webpack_public_path__ + "img/medical-operations-x.fb1f1c86.svg";